import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Media } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { orderBy, uniq, find } from 'lodash';
import { useSession } from '@cordata/buffet';
import { all, spread } from 'axios';

import {
  authorizedPyPublicInstance as Public,
  authorizedInstanceNoBase as full,
  useTopics,
} from '~/utils';

const Message = ({ message }) => (
  <Media className="pb-2">
    <Media left href="#">
      <FontAwesomeIcon icon="user-circle" className="text-tertiary" />
    </Media>

    <Media body className="pl-2">
      <Media heading className={message.isMe && 'text-primary'}>
        {message.author.attributes.displayName}
      </Media>

      {message.body}
    </Media>
  </Media>
);

Message.propTypes = {
  message: PropTypes.shape().isRequired,
};

const MessageList = ({ subscription, currentTopic }) => {
  const [messages, setMessages] = useState([]);

  const { currentAppUser } = useSession();
  const t = useTopics(currentTopic);

  useEffect(() => {
    if (subscription && !Array.isArray(subscription) && subscription.relationships) {
      full
        .get(subscription.relationships.realTimeTopic.related)
        .then(r => r.data.data)
        .then(r =>
          Public
            .get(`patient/${r.attributes.subjectUid}/chat`))
        .then(r => r.data.data)
        .then(r => all([
          r,
          ...uniq(r.map(rr =>
            rr.attributes.createdUid))
            .map(rr =>
              Public
                .get(`app-user/${rr}`)
                .then(u => u.data.data)),
        ]))
        .then(spread((r, ...users) => r.map(rr => ({
          ...rr,
          author: find(users, ['id', rr.attributes.createdUid]),
        }))))
        .then(r => orderBy(r, ['attributes.realTimeMessageSeq']))
        .then((r) => {
          setMessages(r.map(rr => ({
            id: rr.id,
            author: rr.author,
            ...rr.attributes,
            isMe: currentAppUser.id === rr.attributes.createdUid,
          })));

          const messageList = document.querySelector('#message-list');

          messageList.scrollTo(0, messageList.scrollHeight);
        });
    } else {
      setMessages([]);
    }
  }, [subscription, t.newMessages]);

  return messages.map(message =>
    <Message message={message} key={message.id} />);
};

MessageList.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default MessageList;
